import React from "react";

const MapProperties = ({ selectedMap, handleChange, searchTerm }) => {
  const updateIframeCode = (lat, lon, titleMap) => {
    const iframeUrl = `https://maps.google.com/maps?q=${
      lat || 21.232887638669023
    },${lon || 72.86806076829943}&z=13&output=embed`;
    const newIframeCode = `<iframe title="${titleMap || "NextGen"}" src="${iframeUrl}" width="100%" height="100%" style="border:0; border-radius:${
      selectedMap.borderRadius || "0"
    };" allowfullscreen="" loading="lazy"></iframe>`;

    handleChange({ target: { name: "iframeCode", value: newIframeCode } });
  };

  const handleSearch = async () => {
    if (!selectedMap || !selectedMap.searchQuery) return;
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          selectedMap.searchQuery
        )}`
      );
      const data = await response.json();
      if (data.length > 0) {
        const { lat, lon, display_name } = data[0];
        const title = selectedMap.title || display_name;

        handleChange({ target: { name: "lat", value: lat } });
        handleChange({ target: { name: "lng", value: lon } });
        updateIframeCode(lat, lon, title);
      } else {
        alert(
          `Location not found\nTry to get location using Latitude and Longitude`
        );
      }
    } catch (error) {
      console.error("Error searching for location:", error);
    }
  };

  const handleLatLngChange = (e) => {
    const { name, value } = e.target;
    handleChange(e);
    if (name === "lat" || name === "lng") {
      handleChange({ target: { name: "searchQuery", value: "" } });

      const lat = name === "lat" ? value : selectedMap.lat;
      const lon = name === "lng" ? value : selectedMap.lng;
      const title = selectedMap.title || "Location";

      if (lat && lon) {
        updateIframeCode(lat, lon, title);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const lat = selectedMap.lat;
      const lon = selectedMap.lng;
      const title = selectedMap.title || "Location";

      if (lat && lon) {
        updateIframeCode(lat, lon, title);
      } else {
        handleSearch();
      }
    }
  };

  const renderInput = (label, name, type = "text", additionalProps = {}) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div key={name} style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <input
          type={type}
          name={name}
          value={selectedMap && selectedMap[name] ? selectedMap[name] : ""}
          onChange={
            name === "lat" || name === "lng" ? handleLatLngChange : handleChange
          }
          onKeyDown={
            name === "title" || name === "lat" || name === "lng"
              ? handleKeyDown
              : undefined
          }
          style={styles.input}
          {...additionalProps}
        />
      </div>
    );
  };

  const allInputs = [
    <div key="search" style={styles.searchContainer}>
      <input
        type="text"
        name="searchQuery"
        value={
          selectedMap && selectedMap.searchQuery ? selectedMap.searchQuery : ""
        }
        onChange={handleChange}
        placeholder="Search for a location"
        style={styles.searchInput}
        onKeyDown={handleKeyDown}
      />
      <button onClick={handleSearch} style={styles.searchButton}>
        Search
      </button>
    </div>,
    renderInput("Latitude", "lat", "number", { step: "any" }),
    renderInput("Longitude", "lng", "number", { step: "any" }),
    renderInput("Map Title", "titleMap"),
  ];

  const filteredInputs = allInputs.filter((input) => input !== null);

  return (
    <div style={styles.container}>
      <h4 style={styles.heading}>Map Properties</h4>
      {filteredInputs}
    </div>
  );
};

const styles = {
  container: {
    padding: "5px",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    overflow: "hidden",
  },
  heading: {
    fontSize: "15px",
    margin: "10px 0",
    color: "#333",
    borderBottom: "1px solid #ccc",
    paddingBottom: "5px",
  },
  inputGroup: {
    margin: "10px 0",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "3px 5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  searchContainer: {
    display: "block",
    marginBottom: "10px",
  },
  searchInput: {
    flex: 1,
    padding: "5px",
    borderRadius: "3px 0 0 3px",
    border: "1px solid #ccc",
    borderRight: "none",
    width: "100%",
  },
  searchButton: {
    padding: "5px 10px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    marginTop: ".5rem",
  },
  iframePreview: {
    marginTop: "20px",
  },
  iframeTextarea: {
    width: "100%",
    height: "100px",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    resize: "vertical",
  },
};

export default MapProperties;
